import styles from './StrengthsSection.module.css';
import imgQuote from '../../../../assets/images/event/icon-quote-128x128.png'

const strengths = [
  { normal: '서비스 종료 후', highlight: '케어리포트 발송' },
  { normal: '매니저 전원', highlight: '전문자격증 보유' },
  { normal: '전문인', highlight: '배상책임보험 가입' },
];

function StrengthsSection() {
  return (
    <section className={styles.section}>
      {/*<img src={imgQuote} alt="강조" className={styles.strengthQuote} />*/}
      {strengths.map((item, idx) => (
        <div key={idx} className={styles.strengthItem}>
          <span className={styles.normal}>{item.normal}</span>{'\u00A0'}
          <span className={styles.highlight}>{item.highlight}</span>
        </div>
      ))}
      {/*<img src={imgQuote} alt="강조" className={styles.strengthQuoteRev} />*/}
    </section>
  );
}

export default StrengthsSection;
